import { Grid, Skeleton } from '@mui/material'
import React from 'react'

export const ClientProfileSkeleton = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
        <Grid container display={"flex"} flexDirection={"row"} sx={{color: 'primary.main'}} columnGap={15}>
            <Grid item flex={1} display={"flex"} flexDirection={"column"} gap={4}>
                <Grid item display={"flex"} flexDirection={"row"} gap={4}>                    
                        <Skeleton variant='circular' sx={{width: '120px', height: '120px', alignSelf: 'center'}}/>
                        <Grid item display={"flex"} flexDirection={"column"} gap={'16px'}>
                            <Skeleton variant='rectangular' sx={{width: "178px", height:"31px"}}/>
                            <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                                <Skeleton variant='rectangular' sx={{width: "178px", height:"24px"}}/>
                            </Grid>
                            <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                                <Skeleton variant='rectangular' sx={{width: "178px", height:"24px"}}/>
                            </Grid>
                            <Grid item display={"flex"} flexDirection={"row"} gap={1}>
                                <Skeleton variant='rectangular' sx={{width: "178px", height:"24px"}}/>
                            </Grid>
                        </Grid>
                </Grid>
                <Grid item display={"flex"} flexDirection={"column"} >
                    <Skeleton variant='rectangular' sx={{width: "100px", height:"30px", marginBottom: "16px"}}/>
                    <Skeleton variant='rectangular' sx={{width: "640px", height:"174px"}}/>
                </Grid>
                <Grid item display={"flex"} flexDirection={"column"} >
                    <Skeleton variant='rectangular' sx={{width: "100px", height:"30px", marginBottom: "16px"}}/>
                    <Skeleton variant='rectangular' sx={{width: "640px", height:"174px"}}/>
                </Grid>
            </Grid>
            <Grid item flex={1} display={"flex"} flexDirection={"column"} gap={4}>
                <Grid item display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} marginBottom={18}>                        
                    <Skeleton variant='rectangular' sx={{width: "105px", height:"42px"}}/>
                </Grid>
            </Grid>
        </Grid>
        </>
    )
}